<template><div><h1>VUX V2.1.1Rc.2 released</h1>
<h2><a href="/en/components/group.html">Group</a></h2>
<ul><li>[feature] Support title margin-top variable</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] Fix es6 iterator compability, use forEach</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[feature] Add more less variables</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] fix button text color variables</li>
</ul>
<h2><a href="/en/components/x-img.html">XImg</a></h2>
<ul><li>[feature] Support prop:delay</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.2-82.vue?2aa9600a